<template>
  <ul class="list-group list-group-horizontal">
    <button
      :disabled="currentPage === 0"
      style="width: 4rem"
      @click="pickPage(currentPage - 1)"
      class="list-group-item list-group-item-action text-center border-left border-secondary"
    >
      <i class="fa-solid fa-chevron-left"></i>
    </button>

    <button
      @click="pickPage(0)"
      class="list-group-item list-group-item-action text-center border-left border-secondary"
      :class="{ 'page-active': currentPage === 0 }"
    >
      0
    </button>

    <div
      v-if="currentPage !== 0 && currentPage !== 1"
      class="list-group-item text-center d-flex justify-center border-left border-secondary"
    >
      <i class="fa-solid fa-ellipsis align-self-center"></i>
    </div>

    <button
      v-if="currentPage !== 0 && currentPage !== lastPage"
      @click="pickPage(currentPage)"
      class="list-group-item list-group-item-action text-center page-active border-left border-secondary"
    >
      {{ currentPage }}
    </button>

    <div
      v-if="
        totalRowCount !== null &&
        currentPage !== lastPage &&
        currentPage + 1 !== lastPage
      "
      class="list-group-item text-center d-flex justify-center border-left border-secondary"
    >
      <i class="fa-solid fa-ellipsis align-self-center"></i>
    </div>

    <button
      v-if="totalRowCount !== null && lastPage !== 0"
      @click="pickPage(lastPage)"
      class="list-group-item list-group-item-action text-center border-left border-secondary"
      :class="{ 'page-active': currentPage === lastPage }"
    >
      {{ lastPage }}
    </button>

    <button
      :disabled="
        totalRowCount === null || lastPage === 0 || currentPage === lastPage
      "
      style="width: 4rem"
      @click="pickPage(currentPage + 1)"
      class="list-group-item list-group-item-action text-center border-left border-secondary"
    >
      <i class="fa-solid fa-chevron-right"></i>
    </button>
  </ul>
</template>

<script>
export default {
  name: "PagePicker",
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    lastPage: {
      type: Number,
      required: true,
    },
    totalRowCount: {
      type: Number,
      required: false,
      default: null,
    },
  },
  methods: {
    pickPage(page) {
      this.$emit("pagePicked", page);
    },
  },
};
</script>

<style scoped>
.page-active {
  background-color: var(--primary-start) !important;
}
.list-group-item {
    padding: 0.25rem 0.75rem;
}
</style>
